import { MutationTree } from 'vuex';
import { RecommendationsState } from '../../models';
import { IncreasePageMutation } from './mutations/increase-page.mutation';
import { ReplaceStateMutation } from './mutations/replace-state.mutation';
import { SaveRecommendationsMutation } from './mutations/save-recommendations.mutation';
import { SetInfiniteScrollEnabledMutation } from './mutations/set-infinite-scroll-enabled.mutation';
import { SetLastCountMutation } from './mutations/set-last-count.mutation';
import { SetLoadingMutation } from './mutations/set-loading.mutation';
import { SetOriginMutation } from './mutations/set-origin.mutation';
import { SetPageMutation } from './mutations/set-page.mutation';

export const RECOMMENDATIONS_MUTATIONS: MutationTree<RecommendationsState> = {
  ...new SetPageMutation().mutations,
  ...new IncreasePageMutation().mutations,
  ...new ReplaceStateMutation().mutations,
  ...new SaveRecommendationsMutation().mutations,
  ...new SetInfiniteScrollEnabledMutation().mutations,
  ...new SetLoadingMutation().mutations,
  ...new SetLastCountMutation().mutations,
  ...new SetOriginMutation().mutations
};
